import React from 'react';
import { KeyboardArrowDown } from '@mui/icons-material';
import styled from 'styled-components';

const FloatingButton = styled.button<{ visible: boolean }>`
    position: absolute;
    bottom: 80px;
    right: 24px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: none;
    background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    opacity: ${props => props.visible ? 1 : 0};
    transform: ${props => props.visible ? 'scale(1)' : 'scale(0.8)'};
    pointer-events: ${props => props.visible ? 'auto' : 'none'};
    z-index: 10;

    &:hover {
        transform: ${props => props.visible ? 'scale(1.1)' : 'scale(0.8)'};
        box-shadow: 0 6px 16px rgba(102, 126, 234, 0.5);
    }

    &:active {
        transform: scale(0.95);
    }

    .MuiSvgIcon-root {
        font-size: 1.5rem;
    }

    @media (max-width: 768px) {
        bottom: 70px;
        right: 16px;
        width: 36px;
        height: 36px;

        .MuiSvgIcon-root {
            font-size: 1.25rem;
        }
    }
`;

interface ScrollToBottomButtonProps {
    visible: boolean;
    onClick: () => void;
}

const ScrollToBottomButton: React.FC<ScrollToBottomButtonProps> = ({ visible, onClick }) => {
    return (
        <FloatingButton visible={visible} onClick={onClick} aria-label="Aller en bas">
            <KeyboardArrowDown />
        </FloatingButton>
    );
};

export default ScrollToBottomButton;
